import Link from "next/link";
import { ArrowRightLong } from "./ArrowComponents";
import { returnUrlTypeCategory } from "~/utils/utils";

const CategoryComponents = ({ data, tax }) => {
  const singleTerm = data.item.term;
  return (
    <div
      key={data.id}
      className="articleWrap border-box break-inside-avoid text-white hover:opacity-80 print:px-0"
    >
      <h3>
        <Link
          className="text-xl font-bold uppercase md:text-2xl lg:text-3xl"
          href={`${returnUrlTypeCategory(singleTerm.slug, tax).replace(
            "&amp;",
            " & "
          )}/`}
        >
          {singleTerm.name}
        </Link>
      </h3>

      <ArrowRightLong
        href={`${returnUrlTypeCategory(singleTerm.slug, tax).replace(
          "&amp;",
          " & "
        )}/`}
        color={"white"}
        message={"Leggi tutti gli articoli"}
        divStyles={"pt-4 sm:pt-9"}
      />
    </div>
  );
};

export default CategoryComponents;
